module.exports = __webpack_public_path__ + "img/code.8a3a64be.png";